import hasTin from "./helpers/hasTin"
import SendFundsButton from "./SendFundsButton"

export { hasTin }

export default SendFundsButton
